import { useTranslation } from "react-i18next";

import ConfirmModal from "../ConfirmModal";

type Props = {
  /** i18n namespace holding `title`/`description`/`confirm`/`cancel` (and optionally
   * `reactivateDescription`) for this modal - e.g. "pages.editor.publish.freeKeeposLimitReached". */
  i18nKeyPrefix: string;
  /** Use the alternate description key under the same prefix (e.g. "reactivateDescription"). */
  descriptionKey?: string;
  onConfirm: () => void;
  onCancel: () => void;
};

/**
 * Shared "you've reached the free Keepos limit" confirmation modal. Centralizes the
 * copy lookup so every call site always renders a cancel option (ConfirmModal has no
 * default cancel label - omitting `cancelTitle` silently drops the button).
 */
export const FreeKeeposLimitModal = ({ i18nKeyPrefix, descriptionKey, onConfirm, onCancel }: Props) => {
  const { t } = useTranslation();

  return (
    <ConfirmModal
      type="INFO"
      title={t(`${i18nKeyPrefix}.title`)}
      descriptions={[t(`${i18nKeyPrefix}.${descriptionKey || "description"}`)]}
      confirmButtonTitle={t(`${i18nKeyPrefix}.confirm`)}
      cancelTitle={t(`${i18nKeyPrefix}.cancel`)}
      onConfirm={onConfirm}
      onCancel={onCancel}
      tone="plus"
    />
  );
};
